import { useMutation } from '@tanstack/react-query';
import { API_URL, fetchWrapper } from 'src/common/utils/api/fetchWrapper';
import type {
  AutoBrandExtractResponse,
  AutoBrandSourceKind,
} from 'src/secret-menu/auto-brand/types';

type ExtractVars = { file: File; kind: AutoBrandSourceKind };

export const useAutoBrandExtract = (companyId: string) => {
  const { mutateAsync, isPending, error } = useMutation<
    AutoBrandExtractResponse,
    Error,
    ExtractVars
  >({
    mutationFn: async ({ file, kind }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('kind', kind);
      const path = `/admin/companies/${companyId}/auto-brand/extract`;
      const { data } = await fetchWrapper(
        `${API_URL}${path}`,
        { method: 'POST', body: formData },
        `POST ${path}`,
        { timeoutMs: 120_000 },
      );
      return data as AutoBrandExtractResponse;
    },
  });

  return { extract: mutateAsync, isPending, error };
};

export const useAutoBrandTitlePageFromImage = (companyId: string) => {
  const { mutateAsync, isPending, error } = useMutation<{ location: string }, Error, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const path = `/admin/companies/${companyId}/auto-brand/title-page/from-image`;
      const { data } = await fetchWrapper(
        `${API_URL}${path}`,
        { method: 'POST', body: formData },
        `POST ${path}`,
        { timeoutMs: 120_000 },
      );
      return data as { location: string };
    },
  });

  return { buildFromImage: mutateAsync, isPending, error };
};
